import React from 'react';
import PropTypes from 'prop-types';

import { ICON_LIST } from 'Components/Base/Icon/SvgIcon';
import Modal, { ModalContent, ModalFooter } from 'Components/Modal';

const SUBMISSION_VARIANT = {
  ERROR: 'error',
  OVERDUE: 'overdue',
  SUCCESS: 'success',
  FILE_UNREACHABLE: 'FILE_UNREACHABLE',
};

const CONTENT = {
  [SUBMISSION_VARIANT.ERROR]: (
    <ModalContent
      iconName={ICON_LIST.INFO}
      title={'ไม่สามารถบันทึกข้อมูลได้'}
      description={'เนื่องจากระบบเกิดข้อผิดพลาดชั่วคราว กรุณาลองใหม่อีกครั้ง'}
    />
  ),
  [SUBMISSION_VARIANT.OVERDUE]: (
    <ModalContent
      iconName={ICON_LIST.CALENDAR_DATE_RANGE}
      title={'ไม่สามารถบันทึกข้อมูลได้'}
      description={'เนื่องจากเกินระยะเวลาที่กำหนดส่งแล้ว'}
    />
  ),
  [SUBMISSION_VARIANT.FILE_UNREACHABLE]: (
    <ModalContent
      iconName={ICON_LIST.INFO}
      title={'ไม่สามารถดาวน์โหลดไฟล์ได้'}
      description={'เนื่องจากระบบเกิดข้อผิดพลาดชั่วคราว กรุณาลองใหม่อีกครั้ง'}
    />
  ),
  [SUBMISSION_VARIANT.SUCCESS]: (
    <ModalContent
      iconName={ICON_LIST.DONE}
      title={'ส่ง Assignment เรียบร้อย'}
      // description={'คุณจะได้รับอีเมล เมื่อผลการตรวจ Assignment เรียบร้อยสมบูรณ์'}
    />
  ),
};

const AssignmentSubmissionModal = ({ onClose, variant, ...props }) => {
  return (
    <Modal
      key={variant}
      contents={CONTENT[variant]}
      footerProps={{ mt: 7 }}
      footer={
        <ModalFooter
          width={1}
          justifyContent={'center'}
          primaryButtonLabel={'ปิด'}
          onPrimaryButtonClick={onClose}
        />
      }
      {...props}
    />
  );
};

AssignmentSubmissionModal.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(Object.values(SUBMISSION_VARIANT)),
};

export { SUBMISSION_VARIANT };
export default AssignmentSubmissionModal;
